import React from 'react';

const OnboardingFlowConfigContext = React.createContext(null);

export default OnboardingFlowConfigContext;
